import { IMenuItemDetail } from 'src/types/menu.types';
import { ItemResponse } from 'src/api/getItem/types';

export const formatItem = (item: ItemResponse | null): IMenuItemDetail => {
  if (!item) {
    throw new Error('Item not found');
  }

  return {
    itemId: item.item_id,
    code: item.code,
    name: item.name,
    consumerName: item.consumer_name,
    description: item.description,
    prices: item.prices ?? [],
    plu: item.plu,
    type: item.type,
    tax_rate: item.tax_rate,
    image: item.assets[0]?.asset_variants[0]?.url,
    displayOrder: item.display_order,
    parentItemId: item.fk_parent_item_id,
    optionGroup: item.modifier_groups?.map((optionGroup) => ({
      name: optionGroup.name,
      consumer_name: optionGroup.consumer_name,
      optionGroupId: optionGroup.pk_modifier_group_id,
      description: optionGroup.description,
      min: optionGroup.min_choices,
      max: optionGroup.max_choices,
      ranges: optionGroup.ranges || [],
      external_systems: optionGroup.external_systems || [],
      items: optionGroup.modifiers.map((modifier) => ({
        optionItemId: modifier.item_id,
        name: modifier.name,
        posId: modifier.plu,
        valueWithTax: modifier.value_with_tax,
        inheritPrice: modifier.inherit_price,
        inheritPosId: !modifier.plu,
        min: modifier.min_choices,
        max: modifier.max_choices,
        default: modifier.default_choice,
      })),
    })),
    ranges: item.ranges || [],
    rules: item.rules,
    recipe: item.recipe,
    deposit_return_scheme: item.deposit_return_scheme,
    regulatory_statements: item.regulatory_statements?.map((statement) => ({
      ...statement,
      name: typeof statement.name === 'string' ? statement.name : JSON.stringify(statement.name),
      description:
        typeof statement.description === 'string' ? statement.description : JSON.stringify(statement.description ?? ''),
    })),
    categories: item.categories || [],
    party_size: item.party_size,
    instance_configuration: item.instance_configuration,
  };
};
